import React from 'react';
import './Header.css'
const Header = () => {
    return (
        <div>
            <div className="header">
            <h2 className="head-title">Party of poets, who are eternal in Bengali poetry</h2>
            <h2 style={{paddingRight:'120px'}} className="head-title">My poetry Library</h2>
            <h2 className="head-title">Minhajul Islam Galib</h2>
            </div>
            <div className="banner">
             <h2>"যে সব বঙ্গেতে জন্মি হিংসে বঙ্গবাণী, সে সব কাহার জন্ম নির্ণয় ন জানি"</h2>   
             <h2 style={{textAlign: "right",marginRight:'12px'}}>--- আব্দুল হাকিম</h2> 
            </div>
            <div className="header title">
            <h2 className="main-title">15 memorable poets of Bengali language</h2>  
            </div>
        </div>
    );
};

export default Header;